// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"Breadcrumb_breadcrumbContainer__Ayjr1","leftToRight":"Breadcrumb_leftToRight__dsT_n"};